import { PaysafeSelectorStyle } from './paysafe-selector-style.interface';
import { PaysafeSelectors } from './paysafe-selectors.enum';

export type PaysafeStyle = Partial<
  Record<PaysafeSelectors, PaysafeSelectorStyle>
>;
